// extracted by mini-css-extract-plugin
export default {"myModal":"MyModal_myModal__sVaKM","myModalContent":"MyModal_myModalContent__TKrbi","active":"MyModal_active__icDZ7"};